<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <label class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <select class="form-control" v-model="valueProxy" :disabled="disabled">
      <option disabled value="">{{ placeholder }}</option>
      <option v-for="(option, index) in options" :key="index" :value="option[trackKey]">
        {{ option[labelKey] }}
      </option>
    </select>
    <small class="text-danger">{{ errors[0] }}</small>
  </ValidationProvider>
</template>

<script>
  export default {
    name: "SelectField",
    props: {
      label: String,
      value: [String, Number],
      options: Array,
      labelKey: {
        type: String,
        default: "label"
      },
      trackKey: {
        type: String,
        default: "value"
      },
      placeholder: {
        type: String,
        default: "Sélectionnez une option"
      },
      rules: String,
      required: Boolean,
      disabled: Boolean
    },
    computed: {
      valueProxy: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        }
      }
    }
  };
</script>
